<div class="avatar-collapsible">
  @for (collaborator of collaborators; track $index; let i = $index) {
    <div
      class="avatar-wrapper"
      [ngClass]="{ expanded: alwaysExpanded || expandedIndex === i }"
      (mouseenter)="!alwaysExpanded && toggleExpand(i)"
      (mouseleave)="!alwaysExpanded && toggleExpand(null)"
    >
      <!-- Si no se debe comprimir, se muestra siempre la versión expandida -->
      @if (alwaysExpanded) {
        <div class="avatar-expanded">
          <app-avatar
            [name]="collaborator.name + ' ' + collaborator.lastName"
            [label]="collaborator.email"
            [border]="true"
          >
          </app-avatar>
        </div>
      } @else {
        <!-- Versión colapsada: solo las iniciales -->
        @if (expandedIndex !== i) {
          <div class="avatar-collapsed">
            {{ getInitials(collaborator.name + ' ' + collaborator.lastName) }}
          </div>
        }
        <!-- Versión expandida: se muestra el componente app-avatar completo -->
        @if (expandedIndex === i) {
          <div class="avatar-expanded">
            <app-avatar
              [name]="collaborator.name + ' ' + collaborator.lastName"
              [label]="collaborator.email"
              [border]="true"
            >
            </app-avatar>
          </div>
        }
      }
    </div>
  }
</div>
